import Explainer from '../blocks';

import styles from './BuildBrand.module.css';

const EXPLAINER_WIDTH = 662;
const EXPLAINER_HEIGHT = 460;

const BuildBrand = () => {
  return (
    <Explainer
      width={EXPLAINER_WIDTH}
      height={EXPLAINER_HEIGHT}
      className={styles.root}
      once
    >
      <g className={styles.buildContainer}>
        <g transform="translate(2 13)">
          <g filter="url(#filter0_d_4053_24190)">
            <path
              d="M30 32C30 28.6863 32.6863 26 36 26H623.4C626.714 26 629.4 28.6863 629.4 32V634.4C629.4 637.714 626.714 640.4 623.4 640.4H36C32.6863 640.4 30 637.714 30 634.4V32Z"
              fill="white"
            />
            <mask id="path-2-inside-1_4053_24190" fill="white">
              <path d="M30 26H629.4V69.8H30V26Z" />
            </mask>
            <path
              d="M629.4 69.8V69.2H30V69.8V70.4H629.4V69.8Z"
              fill="black"
              fillOpacity="0.05"
              mask="url(#path-2-inside-1_4053_24190)"
            />
            <path
              d="M114.518 52.4264V50.635H114.654L115.885 52.5905C117.212 52.823 118.251 52.3717 118.251 51.3461C118.251 49.8829 114.449 50.6487 114.449 47.8316C114.449 46.2453 115.776 45.5889 117.253 45.5889C117.95 45.5889 118.866 45.8077 119.482 46.0812V47.8726H119.345L118.114 45.9171C116.924 45.6846 116.2 46.1769 116.2 47.0248C116.2 48.6247 120.001 47.8589 120.001 50.5393C120.001 52.0435 118.593 52.9187 116.911 52.9187C116.145 52.9187 115.27 52.741 114.518 52.4264Z"
              fill="#EBCB00"
            />
            <path
              d="M110.555 48.8435C109.694 48.9119 108.983 49.582 108.983 50.8675C108.983 51.5239 109.202 51.9478 109.667 51.9478C109.94 51.9478 110.255 51.8384 110.555 51.6196V48.8435ZM113.769 52.0982V52.235C113.427 52.6863 112.784 52.9187 112.224 52.9187C111.595 52.9187 110.788 52.6999 110.583 51.8247L110.555 51.8111C109.967 52.5495 109.256 52.9187 108.477 52.9187C107.52 52.9187 106.645 52.3444 106.645 51.1546C106.645 49.7461 107.916 48.8435 110.555 48.6521C110.555 46.8333 109.844 46.2589 108.901 46.2589C108.395 46.2589 107.821 46.4231 107.274 46.6419L107.233 46.5325C107.957 45.9718 108.997 45.5889 110.05 45.5889C111.499 45.5889 112.825 46.3136 112.825 48.3512V51.4692C112.825 51.9615 113.017 52.0982 113.769 52.0982Z"
              fill="#EBCB00"
            />
            <path
              d="M103.026 48.8435C102.165 48.9119 101.454 49.582 101.454 50.8675C101.454 51.5239 101.672 51.9478 102.137 51.9478C102.411 51.9478 102.725 51.8384 103.026 51.6196V48.8435ZM106.24 52.0982V52.235C105.898 52.6863 105.255 52.9187 104.695 52.9187C104.065 52.9187 103.259 52.6999 103.054 51.8247L103.026 51.8111C102.438 52.5495 101.727 52.9187 100.948 52.9187C99.9904 52.9187 99.1152 52.3444 99.1152 51.1546C99.1152 49.7461 100.387 48.8435 103.026 48.6521C103.026 46.8333 102.315 46.2589 101.372 46.2589C100.866 46.2589 100.291 46.4231 99.7443 46.6419L99.7032 46.5325C100.428 45.9718 101.467 45.5889 102.52 45.5889C103.97 45.5889 105.296 46.3136 105.296 48.3512V51.4692C105.296 51.9615 105.488 52.0982 106.24 52.0982Z"
              fill="#EBCB00"
            />
            <path
              d="M91.5176 52.1531V49.8557H91.6543L93.35 52.5907C95.114 52.8642 96.4678 52.1668 96.4678 50.8539C96.4678 48.789 91.5176 49.1856 91.5176 45.7395C91.5176 44.1942 92.6799 42.8813 94.9363 42.8813C96.3174 42.8813 97.1652 43.1275 98.0131 43.5104V45.589H97.8763L96.249 43.1959C94.485 42.9224 93.6098 43.6745 93.6098 44.8369C93.6098 46.9976 98.5601 46.4642 98.5601 49.9104C98.5601 51.8796 96.7413 52.9189 94.444 52.9189C93.3773 52.9189 92.5295 52.6454 91.5176 52.1531Z"
              fill="#EBCB00"
            />
            <path
              d="M90.3235 51.7153L90.3646 51.8247C89.6125 52.5495 88.6142 52.9187 87.6296 52.9187C85.7425 52.9187 84.1426 51.8111 84.1426 49.3906C84.1426 46.9427 85.9887 45.5889 87.7117 45.5889C89.6808 45.5889 90.8705 46.8333 90.474 49.1581H86.5493C86.563 51.6059 87.4245 52.0299 88.5048 52.0299C89.0244 52.0299 89.6945 51.9341 90.3235 51.7153ZM87.6843 45.794C87.151 45.794 86.563 46.7102 86.5493 48.9803L88.4091 48.8846C88.5322 46.8333 88.245 45.794 87.6843 45.794Z"
              fill="#171717"
            />
            <path
              d="M78.2359 46.806C78.2906 46.9701 78.4 47.2709 78.4 47.8863V52.276L79.07 52.6179V52.7546H75.4599V52.6179L76.13 52.276V47.5034C76.13 46.7239 75.7881 46.4231 75.3232 46.4231C74.995 46.4231 74.5437 46.5872 74.1471 46.847V52.276L74.8172 52.6179V52.7546H70.9336V52.6179L71.8771 52.276V46.5598L70.9336 46.2589V46.1495L74.0651 45.5889L74.1471 45.6572V46.6419L74.1745 46.6555C74.8035 45.9034 75.5967 45.5889 76.4172 45.5889C77.1556 45.5889 77.853 45.8897 78.1812 46.6419L78.2085 46.6555C79.0427 45.835 79.7538 45.5889 80.67 45.5889C81.6819 45.5889 82.6528 46.1359 82.6528 47.8863V52.276L83.5964 52.6179V52.7546H79.7128V52.6179L80.3828 52.276V47.5034C80.3828 46.7239 80.0409 46.4231 79.576 46.4231C79.2478 46.4231 78.7555 46.5188 78.2359 46.806Z"
              fill="#171717"
            />
            <path
              d="M66.5708 48.9666C66.5708 51.2914 67.5827 52.0299 68.663 52.0299C69.1827 52.0299 69.716 51.9341 70.345 51.7153L70.3861 51.8247C69.7023 52.5495 68.663 52.9187 67.7879 52.9187C65.8461 52.9187 64.1641 51.6196 64.1641 49.2538C64.1641 47.3119 65.6273 45.5889 68.1297 45.5889C68.7314 45.5889 69.4152 45.6709 70.1536 45.9444V48.1461H70.0168L68.6904 45.835C67.8426 45.835 66.5708 46.3957 66.5708 48.9666Z"
              fill="#171717"
            />
            <path
              d="M56.2974 49.2805H59.5109L58.4033 46.3814L57.911 45.0276H57.8836L57.3913 46.3677L56.2974 49.2805ZM59.6066 49.5267H56.2153L55.3128 51.9335L56.899 52.6856V52.754H54V52.6856L54.9983 51.9335L58.4033 43.0447H59.8938L63.3809 52.2754L64.1603 52.6173V52.754H59.5656V52.6173L60.6459 52.2754L59.6066 49.5267Z"
              fill="#171717"
            />
            <text
              opacity="0.15"
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="10.8"
              letterSpacing="0em"
            >
              <tspan x="129.602" y="50.7319">
                {' '}
                /
              </tspan>
            </text>
            <g clipPath="url(#clip0_4053_24190)">
              <text
                fill="black"
                fontFamily="var(--font-family-body)"
                fontSize="9.6"
                letterSpacing="0.005em"
              >
                <tspan x="154.002" y="50.3839">
                  gateway-30
                </tspan>
              </text>
            </g>
            <path
              d="M506.933 43.0999L511.2 47.3665V48.4329L506.933 52.6995H505.866L501.6 48.4329V47.3665L505.866 43.0999H506.933ZM506.4 45.6858C505.178 45.6858 504.186 46.6771 504.186 47.8997C504.186 49.1224 505.178 50.1145 506.4 50.1145C507.623 50.1143 508.614 49.1223 508.614 47.8997C508.614 46.6772 507.623 45.686 506.4 45.6858Z"
              fill="black"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="8.4"
              letterSpacing="0.005em"
            >
              <tspan x="518.4" y="50.2359">
                Powered by Cloudsmith
              </tspan>
            </text>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M59.9066 98.8235H61.1421H61.2561H62.4915L63.1426 99.5359L63.1426 101.499H64.1427L65.3083 102.782V103.743V106.087V107.048L64.1427 108.332H58.2554L57.0898 107.048V106.087V103.743V102.782L58.2554 101.499H59.2555L59.2555 99.5359L59.9066 98.8235ZM64.4083 103.13V103.743V106.087V106.7L63.7442 107.432H58.6539L57.9898 106.7V106.087V103.743V103.13L58.6539 102.399H63.7442L64.4083 103.13ZM60.1555 101.499H62.2426L62.2426 99.8852L62.0948 99.7235L61.2561 99.7235H61.1421L60.3033 99.7235L60.1555 99.8852L60.1555 101.499ZM60.8061 103.743V106.18H61.7061V103.743H60.8061Z"
              fill="black"
              fillOpacity="0.6"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-headline)"
              fontSize="14.4"
              letterSpacing="0em"
            >
              <tspan x="72.4102" y="108.44">
                gateway-30
              </tspan>
            </text>
            <path
              d="M605.6 95.3997V112.401L604.2 113.8H518.199L516.6 112.2V95.5999L518.399 93.8H604L605.6 95.3997Z"
              fill="#FFDC00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M525.899 100.377V104.628L524.21 102.94L523.786 103.364L525.706 105.283H526.692L528.612 103.364L528.187 102.94L526.499 104.628V100.377H525.899ZM524.365 106.293L523.114 104.886L522.666 105.285L524.095 106.893H525.685H526.713H528.303L529.732 105.285L529.283 104.886L528.033 106.293H526.713H525.685H524.365Z"
              fill="black"
              fillOpacity="0.6"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-headline)"
              fontSize="7.2"
              letterSpacing="0.02em"
            >
              <tspan x="534.986" y="105.92">
                Download Packages
              </tspan>
            </text>
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="6.6"
              letterSpacing="0.0075em"
            >
              <tspan x="54" y="129.31">
                5
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="6.6"
              letterSpacing="0.015em"
            >
              <tspan x="61.4004" y="129.31">
                Packages
              </tspan>
            </text>
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="6.6"
              letterSpacing="0.0075em"
            >
              <tspan x="106.4" y="129.31">
                123
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="6.6"
              letterSpacing="0.015em"
            >
              <tspan x="121.801" y="129.11">
                MB
              </tspan>
            </text>
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="6.6"
              letterSpacing="0.0075em"
            >
              <tspan x="142.801" y="129.31">
                100
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="6.6"
              letterSpacing="0.015em"
            >
              <tspan x="158.201" y="129.11">
                Downloads
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="6.6"
              letterSpacing="0.015em"
            >
              <tspan x="208.199" y="129.11">
                Read-only
              </tspan>
            </text>
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="8.4"
              letterSpacing="0em"
            >
              <tspan x="54" y="146.236">
                This is the broadcast description. Lorem ipsum dolor sit amet,
                consectetur adipiscing elit. Pellentesque a{' '}
              </tspan>
              <tspan x="54" y="158.236">
                risus metus. In blandit feugiat ligula vitae consectetur.
                Curabitur laoreet vulputate sollicitudin. Aliquam{' '}
              </tspan>
              <tspan x="54" y="170.236">
                congue mollis laoreet.
              </tspan>
            </text>
            <mask id="path-31-inside-2_4053_24190" fill="white">
              <path d="M30 185.8H629.4V221.8H30V185.8Z" />
            </mask>
            <path
              d="M629.4 221.8V221.2H30V221.8V222.4H629.4V221.8Z"
              fill="black"
              fillOpacity="0.05"
              mask="url(#path-31-inside-2_4053_24190)"
            />
            <mask id="path-33-inside-3_4053_24190" fill="white">
              <path d="M54 185.8H96.2V221.8H54V185.8Z" />
            </mask>
            <path
              d="M96.2 221.8V219.4H54V221.8V224.2H96.2V221.8Z"
              fill="#FFDC00"
              mask="url(#path-33-inside-3_4053_24190)"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="9.6"
              letterSpacing="0.005em"
            >
              <tspan x="54.5996" y="206.484">
                Packages
              </tspan>
            </text>
            <rect
              x="54"
              y="233.8"
              width="177.198"
              height="26"
              rx="2.4"
              fill="white"
            />
            <rect
              x="54.3"
              y="234.1"
              width="176.598"
              height="25.4"
              rx="2.1"
              stroke="black"
              strokeOpacity="0.05"
              strokeWidth="0.6"
              fill="transparent"
            />
            <path
              d="M63 249.26L64.9849 247.275L65.4346 247.725L63.4497 249.71L63 249.26Z"
              fill="black"
              fillOpacity="0.6"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M66.635 247.545C67.4936 247.545 68.1895 246.849 68.1895 245.99C68.1895 245.132 67.4936 244.436 66.635 244.436C65.7765 244.436 65.0805 245.132 65.0805 245.99C65.0805 246.849 65.7765 247.545 66.635 247.545ZM66.635 248.181C67.8448 248.181 68.8255 247.2 68.8255 245.99C68.8255 244.781 67.8448 243.8 66.635 243.8C65.4253 243.8 64.4446 244.781 64.4446 245.99C64.4446 247.2 65.4253 248.181 66.635 248.181Z"
              fill="black"
              fillOpacity="0.6"
            />
            <text
              fill="black"
              fillOpacity="0.5"
              fontFamily="var(--font-family-body)"
              fontSize="9.6"
              letterSpacing="0.005em"
            >
              <tspan x="76.8008" y="249.184">
                Search 5 packages
              </tspan>
            </text>
            <rect
              x="526.199"
              y="233.8"
              width="79.2"
              height="26"
              rx="2.4"
              fill="white"
            />
            <rect
              x="526.499"
              y="234.1"
              width="78.6"
              height="25.4"
              rx="2.1"
              stroke="black"
              strokeOpacity="0.05"
              strokeWidth="0.6"
              fill="transparent"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="9.6"
              letterSpacing="0.005em"
            >
              <tspan x="533" y="249.184">
                Name (A-Z)
              </tspan>
            </text>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M590.551 245.872L590.975 245.447L593.441 247.913H594.232L596.62 245.451L597.051 245.868L594.486 248.513H593.192L590.551 245.872Z"
              fill="black"
              fillOpacity="0.6"
            />
            <mask id="path-44-inside-4_4053_24190" fill="white">
              <path d="M54 269.4H604.8V303H54V269.4Z" />
            </mask>
            <path
              d="M604.8 303V302.4H54V303V303.6H604.8V303Z"
              fill="black"
              fillOpacity="0.05"
              mask="url(#path-44-inside-4_4053_24190)"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="9.6"
              fontWeight="600"
              letterSpacing="0.005em"
            >
              <tspan x="63.5996" y="288.884">
                Name
              </tspan>
            </text>
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="9.6"
              fontWeight="600"
              letterSpacing="0.005em"
            >
              <tspan x="150" y="288.884">
                Version
              </tspan>
            </text>
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="9.6"
              fontWeight="600"
              letterSpacing="0.005em"
            >
              <tspan x="340.801" y="288.884">
                Tags
              </tspan>
            </text>
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="9.6"
              fontWeight="600"
              letterSpacing="0.005em"
            >
              <tspan x="434.4" y="288.884">
                Downloads
              </tspan>
            </text>
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="9.6"
              fontWeight="600"
              letterSpacing="0.005em"
            >
              <tspan x="528" y="288.884">
                Size
              </tspan>
            </text>
            <mask id="path-51-inside-5_4053_24190" fill="white">
              <path d="M54 302.4H604.8V336H54V302.4Z" />
            </mask>
            <path
              d="M604.8 336V335.4H54V336V336.6H604.8V336Z"
              fill="black"
              fillOpacity="0.05"
              mask="url(#path-51-inside-5_4053_24190)"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="9.6"
              letterSpacing="0.005em"
            >
              <tspan x="63.5996" y="321.884">
                aws-sdk
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="8.4"
              letterSpacing="0.0075em"
            >
              <tspan x="150" y="322.04">
                @2.1354.0
              </tspan>
            </text>
            <rect
              x="340.801"
              y="312.1"
              width="21.6"
              height="14.2"
              rx="2.4"
              fill="#FFDC00"
              fillOpacity="0.25"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="6"
              letterSpacing="0.04em"
            >
              <tspan x="345.868" y="321.1">
                gem
              </tspan>
            </text>
            <rect
              x="367.201"
              y="312.1"
              width="25.6"
              height="14.2"
              rx="2.4"
              fill="#FFDC00"
              fillOpacity="0.25"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="6"
              letterSpacing="0.04em"
            >
              <tspan x="372.318" y="321.1">
                ruby
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="8.4"
              letterSpacing="0.0075em"
            >
              <tspan x="434.4" y="322.14">
                &#x2014;
              </tspan>
            </text>
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="8.4"
              letterSpacing="0.0075em"
            >
              <tspan x="528" y="322.14">
                123
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="7.2"
              letterSpacing="0.015em"
            >
              <tspan x="546.4" y="322.52">
                kB
              </tspan>
            </text>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M585.225 315.171V320.485L583.114 318.375L582.584 318.905L584.983 321.304H586.216L588.616 318.905L588.085 318.375L585.975 320.485V315.171H585.225ZM583.307 322.566L581.744 320.808L581.184 321.306L582.97 323.316H584.957H586.242H588.229L590.016 321.306L589.455 320.808L587.893 322.566H586.242H584.957H583.307Z"
              fill="black"
              fillOpacity="0.6"
            />
            <mask id="path-64-inside-6_4053_24190" fill="white">
              <path d="M54 335.4H604.8V369H54V335.4Z" />
            </mask>
            <path
              d="M604.8 369V368.4H54V369V369.6H604.8V369Z"
              fill="black"
              fillOpacity="0.05"
              mask="url(#path-64-inside-6_4053_24190)"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="9.6"
              letterSpacing="0.005em"
            >
              <tspan x="63.5996" y="354.884">
                http
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="8.4"
              letterSpacing="0.0075em"
            >
              <tspan x="150" y="355.04">
                @0.6.1
              </tspan>
            </text>
            <rect
              x="340.801"
              y="345.1"
              width="21.6"
              height="14.2"
              rx="2.4"
              fill="#FFDC00"
              fillOpacity="0.25"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="6"
              letterSpacing="0.04em"
            >
              <tspan x="345.868" y="354.1">
                gem
              </tspan>
            </text>
            <rect
              x="367.201"
              y="345.1"
              width="25.6"
              height="14.2"
              rx="2.4"
              fill="#FFDC00"
              fillOpacity="0.25"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="6"
              letterSpacing="0.04em"
            >
              <tspan x="372.318" y="354.1">
                ruby
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="8.4"
              letterSpacing="0.0075em"
            >
              <tspan x="434.4" y="355.14">
                &#x2014;
              </tspan>
            </text>
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="8.4"
              letterSpacing="0.0075em"
            >
              <tspan x="528" y="355.14">
                123
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="7.2"
              letterSpacing="0.015em"
            >
              <tspan x="546.4" y="355.52">
                kB
              </tspan>
            </text>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M585.225 348.171V353.485L583.114 351.375L582.584 351.905L584.983 354.304H586.216L588.616 351.905L588.085 351.375L585.975 353.485V348.171H585.225ZM583.307 355.566L581.744 353.808L581.184 354.306L582.97 356.316H584.957H586.242H588.229L590.016 354.306L589.455 353.808L587.893 355.566H586.242H584.957H583.307Z"
              fill="black"
              fillOpacity="0.6"
            />
            <mask id="path-77-inside-7_4053_24190" fill="white">
              <path d="M54 368.4H604.8V402H54V368.4Z" />
            </mask>
            <path
              d="M604.8 402V401.4H54V402V402.6H604.8V402Z"
              fill="black"
              fillOpacity="0.05"
              mask="url(#path-77-inside-7_4053_24190)"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="9.6"
              letterSpacing="0.005em"
            >
              <tspan x="63.5996" y="387.884">
                http
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="8.4"
              letterSpacing="0.0075em"
            >
              <tspan x="150" y="388.04">
                @0.6.1
              </tspan>
            </text>
            <rect
              x="340.801"
              y="378.1"
              width="21.6"
              height="14.2"
              rx="2.4"
              fill="#FFDC00"
              fillOpacity="0.25"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="6"
              letterSpacing="0.04em"
            >
              <tspan x="345.868" y="387.1">
                gem
              </tspan>
            </text>
            <rect
              x="367.201"
              y="378.1"
              width="25.6"
              height="14.2"
              rx="2.4"
              fill="#FFDC00"
              fillOpacity="0.25"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="6"
              letterSpacing="0.04em"
            >
              <tspan x="372.318" y="387.1">
                ruby
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="8.4"
              letterSpacing="0.0075em"
            >
              <tspan x="434.4" y="388.14">
                &#x2014;
              </tspan>
            </text>
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="8.4"
              letterSpacing="0.0075em"
            >
              <tspan x="528" y="388.14">
                123
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="7.2"
              letterSpacing="0.015em"
            >
              <tspan x="546.4" y="388.52">
                kB
              </tspan>
            </text>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M585.225 381.171V386.485L583.114 384.375L582.584 384.905L584.983 387.304H586.216L588.616 384.905L588.085 384.375L585.975 386.485V381.171H585.225ZM583.307 388.566L581.744 386.808L581.184 387.306L582.97 389.316H584.957H586.242H588.229L590.016 387.306L589.455 386.808L587.893 388.566H586.242H584.957H583.307Z"
              fill="black"
              fillOpacity="0.6"
            />
            <mask id="path-90-inside-8_4053_24190" fill="white">
              <path d="M54 401.4H604.8V435H54V401.4Z" />
            </mask>
            <path
              d="M604.8 435V434.4H54V435V435.6H604.8V435Z"
              fill="black"
              fillOpacity="0.05"
              mask="url(#path-90-inside-8_4053_24190)"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-body)"
              fontSize="9.6"
              letterSpacing="0.005em"
            >
              <tspan x="63.5996" y="420.884">
                http
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="8.4"
              letterSpacing="0.0075em"
            >
              <tspan x="150" y="421.04">
                @0.6.1
              </tspan>
            </text>
            <rect
              x="340.801"
              y="411.1"
              width="21.6"
              height="14.2"
              rx="2.4"
              fill="#FFDC00"
              fillOpacity="0.25"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="6"
              letterSpacing="0.04em"
            >
              <tspan x="345.868" y="420.1">
                gem
              </tspan>
            </text>
            <rect
              x="367.201"
              y="411.1"
              width="25.6"
              height="14.2"
              rx="2.4"
              fill="#FFDC00"
              fillOpacity="0.25"
            />
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="6"
              letterSpacing="0.04em"
            >
              <tspan x="372.318" y="420.1">
                ruby
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="8.4"
              letterSpacing="0.0075em"
            >
              <tspan x="434.4" y="421.14">
                &#x2014;
              </tspan>
            </text>
            <text
              fill="black"
              fontFamily="var(--font-family-mono)"
              fontSize="8.4"
              letterSpacing="0.0075em"
            >
              <tspan x="528" y="421.14">
                123
              </tspan>
            </text>
            <text
              fill="black"
              fillOpacity="0.6"
              fontFamily="var(--font-family-mono)"
              fontSize="7.2"
              letterSpacing="0.015em"
            >
              <tspan x="546.4" y="421.52">
                kB
              </tspan>
            </text>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M585.225 414.171V419.485L583.114 417.375L582.584 417.905L584.983 420.304H586.216L588.616 417.905L588.085 417.375L585.975 419.485V414.171H585.225ZM583.307 421.566L581.744 419.808L581.184 420.306L582.97 422.316H584.957H586.242H588.229L590.016 420.306L589.455 419.808L587.893 421.566H586.242H584.957H583.307Z"
              fill="black"
              fillOpacity="0.6"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_4053_24190"
              x="0"
              y="0"
              width="659.4"
              height="674.4"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="15" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.847059 0 0 0 0 0.596078 0 0 0 0 0.164706 0 0 0 0.15 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_4053_24190"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_4053_24190"
                result="shape"
              />
            </filter>
            <clipPath id="clip0_4053_24190">
              <rect
                x="149.201"
                y="38"
                width="59.4"
                height="19.8"
                rx="2.4"
                fill="white"
              />
            </clipPath>
          </defs>
        </g>
      </g>
    </Explainer>
  );
};

export default BuildBrand;
